import React from 'react';
import { Image, Eye16 as IconShow16, Comments16 as IconComment16 } from '@cian/ui-kit';

import { Chip } from '../Chip';
import { IArticlesMainAttributesSchema } from '../../repositories/journal/entities/journal/ArticlesMainAttributesSchema';
import { IArticlesMainAttributesRubricSchema } from '../../repositories/journal/entities/journal/ArticlesMainAttributesRubricSchema';
import { numberWithDelimiter } from '../../utils';
import * as s from './MainArticleDetailed.css';

export interface IMainArticleDetailed extends Pick<IArticlesMainAttributesSchema, 'title' | 'image' | 'commentsCount'> {
  rubric?: IArticlesMainAttributesRubricSchema;
  viewsCount: IArticlesMainAttributesSchema['numViews'];
  onRubricButtonClick?(e: React.MouseEvent, url: IArticlesMainAttributesRubricSchema['url']): void;
  onClick(e: React.MouseEvent): void;
}

/** Топовая статья на Главной (полный вид) */
export const MainArticleDetailed = ({
  image,
  title,
  rubric,
  viewsCount,
  commentsCount,
  onClick,
  onRubricButtonClick,
}: IMainArticleDetailed) => {
  return (
    <div className={`${s['wrapper']}`} onClick={onClick}>
      <div className={`${s['content-wrapper']}`}>
        <div className={`${s['activity-panel']}`}>
          {rubric && (
            <Chip
              size={'XS'}
              theme="stroke_secondary"
              onClick={e => onRubricButtonClick && onRubricButtonClick(e, rubric.url)}
            >
              {rubric.name}
            </Chip>
          )}

          <div className={`${s['views']}`}>
            <IconShow16 />
            {numberWithDelimiter(viewsCount)}
          </div>

          <div className={`${s['comments']}`}>
            <IconComment16 />
            {numberWithDelimiter(commentsCount)}
          </div>
        </div>

        <div className={`${s['title']}`}>{title}</div>
      </div>

      <Image alt={title} borderRadius={0} objectFit="cover" preloader src={image || ''} theme="light" title={title} />
    </div>
  );
};
